import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { FleetView } from '../components/FleetView';
import { useLayout } from '@shared/contexts/LayoutContext';

export const FleetPage: React.FC = () => {
    const navigate = useNavigate();
    const { layoutMode } = useLayout();

    return (
        <div className="min-h-screen bg-app pb-20">
            {/* Navigation Wrapper */}
            <div className="relative">
                {layoutMode !== 'sidebar' && (
                    <div className="absolute top-6 left-6 z-10 md:hidden">
                        <button
                            onClick={() => navigate('/')}
                            className="p-2 bg-black/40 backdrop-blur-md border border-white/10 rounded-full text-white hover:bg-white/10 transition-colors"
                        >
                            <ArrowLeft size={20} />
                        </button>
                    </div>
                )}

                <FleetView />
            </div>
        </div>
    );
};
